export default __webpack_public_path__ + "static/Treegraphvertical-2-81a899631f26c65f90a73e580417da04.jpg";